import React, { useContext, useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import logo from '../../assets/biztrade_logo/logo.png'
import img from '../../assets/forgot_password/Login-amico.png'
import { Auth } from '../../contexts/allContext'
import { apiV1 } from '../../utils/api'
import classes from './ResetPassword.module.css'

const ResetPassword = () => {
    const { stateAuth, dispatchAuth } = useContext(Auth)
    const [showPassword1, setShowPassword1] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (password !== confirmPassword) {
            toast.error('Passwords do not match!', {
                position: 'top-center',
            })
            return
        }

        const token = stateAuth.token
        if (!token) {
            toast.error('Unauthorized. Please log in again.', {
                position: 'top-center',
            })
            return
        }

        try {
            const response = await fetch(`${apiV1}/users/password/`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json',
                },
                body: JSON.stringify({ password }),
            })

            if (response.ok) {
                toast.success('Password changed successfully!', {
                    position: 'top-center',
                })
                dispatchAuth({ type: 'remove' }) // Clear auth state
                setTimeout(() => {
                    navigate('/')
                }, 1000) // wait 1.5s for toast to show
            } else {
                const errorData = await response.json()
                toast.error(errorData.message || 'Failed to update password', {
                    position: 'top-center',
                })
            }
        } catch (err) {
            toast.error('Something went wrong. Please try again.')
            console.error(err)
        }
    }

    return (
        <div className={classes.wrapper}>
            <a href="/">
                <img src={logo} alt="BizTrade Logo" />
            </a>
            <div className={classes.box}>
                <div>
                    <img src={img} alt="Forgot Password Illustration" />
                </div>
                <div>
                    <h3>
                        Reset
                        <br />
                        Password!
                    </h3>
                    <p>
                        Enter strong password to protect your account!
                        <span>*</span>
                    </p>

                    <form onSubmit={handleSubmit}>
                        {/* Password Field */}
                        <div className={classes.inputWrapper}>
                            <input
                                type={showPassword1 ? 'text' : 'password'}
                                placeholder="Enter password *"
                                minLength="4"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <span
                                className={classes.passwordToggleIcon}
                                onClick={() => setShowPassword1(!showPassword1)}
                                aria-label="Toggle password visibility"
                                role="button"
                                tabIndex={0}>
                                {showPassword1 ? <FaEye /> : <FaEyeSlash />}
                            </span>
                        </div>

                        {/* Confirm Password Field */}
                        <div className={classes.inputWrapper}>
                            <input
                                type={showPassword2 ? 'text' : 'password'}
                                placeholder="Confirm password *"
                                minLength="4"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <span
                                className={classes.passwordToggleIcon}
                                onClick={() => setShowPassword2(!showPassword2)}
                                aria-label="Toggle password visibility"
                                role="button"
                                tabIndex={0}>
                                {showPassword2 ? <FaEye /> : <FaEyeSlash />}
                            </span>
                        </div>

                        <button type="submit">Change Password</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword
